const ESCAPE_CHARS_REGEX = /[.*+?^${}()|[\]\\]/g

// eslint-disable-next-line import/prefer-default-export
export function escapeRegExp(s: string): string {
  return s.replace(ESCAPE_CHARS_REGEX, '\\$&')
}
